// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "common-63e89354" + "." + "6d505803" + ".chunk.css";
};